module.exports = __webpack_public_path__ + "img/30.e8efbc3a.png";